<template>
    <div class="mix-order-detail" v-if="viewData">
        <div class="order-list-box _box">
            <header>合并订单</header>
            <section>
                <order-card v-for="order in viewData['order']" class="order-card" :key="order['id']"
                            :is-merge="true"
                            :view-data="order"/>
            </section>
        </div>
        <div class="order-detail _box">
            <header>合并订单信息</header>
            <section>
                <div class="row _flex" v-if="viewData['order_no']">
                    <span>订单编号：{{viewData['order_no']}}</span>
                    <button :data-clipboard-text="viewData['order_no']" class="clip-btn">复制</button>
                </div>
                <div class="row" v-if="viewData['paid_at']">
                    <span>下单时间：{{viewData['paid_at']}}</span>
                </div>
                <div class="row" v-if="viewData['order_price']">
                    <span>总价：¥{{makePrice(viewData['order_price'])}}</span>
                </div>
                <div class="row" v-for="item in viewData['discounts']" :key="item.name">
                    <span>{{item.name}}：<span style="color: #F63D30;">¥{{makePrice(item.price)}}</span></span>
                </div>
                <!-- <div class="row" v-if="viewData['order_discount']">
                    <span>合并订单优惠：<span style="color: #F63D30;">¥{{makePrice(viewData['order_discount'])}}</span></span>
                </div> -->
                <div class="row" v-if="viewData['paid']">
                    <span>实付：¥{{makePrice(viewData['paid'])}}</span>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import OrderCard from "../components/OrderCard.vue";
import Moment from 'moment';
import {Toast} from 'mint-ui'

export default {
    name: 'OrderDetailMixed',
    components: {OrderCard},
    data() {
        return {
            viewData: null,
            clipboard: null,
        }
    },
    mounted() {
        let order_id = this.$route.params.order_id;
        let viewData = this.$store.getters.getMixOrders[order_id];
        viewData['paid_at'] = Moment(viewData['paid_at']).format('YYYY-MM-DD HH:SS:mm');
        viewData['paid'] = viewData['order_price'] - viewData['order_discount'];
        this.$set(this, 'viewData', viewData);
        console.log(viewData)
        // init ClipBoardJs
        const echoSuccess = (e) => console.log(`${e.action} success! value is: \n${e.text}`);
        import(/* webpackChunkName: "clipboard" */ 'clipboard')
          .then(({default: ClipboardJS}) => {
              this.clipboard = new ClipboardJS('.clip-btn');
              this.clipboard.on('success', e => { 
                  echoSuccess(e);
                  Toast('已复制到剪贴板');
              });
          })
    },

    methods: {
        makePrice(price) {
            const afterDot = price%100;
            return `${parseInt(price/100)}.${afterDot<10?`0${afterDot}`:afterDot}`;
        }
    },
}
</script>

<style lang="scss" scoped>
.mix-order-detail {
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
    padding: 16px;

    ._box {
        width: 100%;
        box-shadow: 0 2px 14px 0 rgba(221,221,221,0.5);
        border-radius: 5px;
        margin-bottom: 16px;

        header {
            padding: 12px 16px;
            border-bottom: 1px solid rgba(151, 151, 151, 0.15);
            color: rgba(54, 54, 54, 0.99);
            font-size: 14px;
            font-weight: bold;
        }

        section {
            padding: 13px 16px;

            .order-card {
                + .order-card {
                    margin-top: 24px;
                }
            }

            .row {
                font-size: 14px;

                & + .row {
                    margin-top: 12px;
                }

                &._flex {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
        }
    }

    .clip-btn {
        font-size: 12px;
        border: 1px solid #363636;
        opacity: 0.7;
        color: #363636;
        padding: 2px 7px;
        border-radius: 2px;
    }
}
</style>
